import instance from "../../../connection/instance";
import { useState } from "react";
import { notifications } from '@mantine/notifications';

const usePlace = (t) => {
  const [profile, setProfile] = useState();
  
  const fetch = async () => {
    const { data: { response, errors: fetchErrors }} = await instance.get(`/api/user/current`);
    const { errors, ...data } = await fetchOrganization(response.org);

    if (fetchErrors?.length > 0 || errors?.length > 0) {
      return { errors: [...fetchErrors, ...errors] }
    }

    setProfile({
      ...response,
      organizationName: data.name
    });

    return {
      ...response,
      organizationName: data.name
    };
  }

  const fetchOrganization = async (id) => {
    const { data: { response, errors: fetchErrors }} = await instance.get(`/api/org/${id}`);

    if (fetchErrors?.length > 0) {
      return { errors: fetchErrors }
    }

    return response;
  }

  const update = async (data) => {
    const { data: { response, errors: fetchErrors }} = await instance.put(`/api/user/current`, data);

    if (fetchErrors?.length > 0) {
      notifications.show({
        title: t('notifications.place.error'),
        autoClose: 2000
      });

      return { errors: fetchErrors }
    }

    notifications.show({
      title: t('notifications.profile.success'),
      autoClose: 2000
    });

    return response
  }

  const updateOrg = async (data) => {
    const name = data.organizationName;
    const { data: { response, errors: fetchErrors }} = await instance.put(`/api/org/${profile.org}`, { name });

    if (fetchErrors?.length > 0) {
      notifications.show({
        title: t('notifications.place.error'),
        autoClose: 2000
      });
      
      return { errors: fetchErrors }
    }

    notifications.show({
      title: t('notifications.org.success'),
      autoClose: 2000
    });
  }

  return [
    {
      profile
    },
    {
      fetch,
      update,
      updateOrg
    }
  ]
}

export default usePlace;
